export default "__VITE_PUBLIC_ASSET__0a8dda8f__"